export default __webpack_public_path__ + "static/media/instagram_social.79a8130a.svg";